export default function (http,baseUrl,uploadUrl) {
    return {
      getDetail(params) {
		console.log(uploadUrl);
        return http.get(`${baseUrl}/book/sale/`+params);
      }
    }
  }